import { Component } from '@angular/core';
import { ForgotPasswordComponent } from 'gung-standard';

@Component({
  selector: 'car-liner-forgot-password',
  templateUrl: './car-liner-forgot-password.component.html',
  styleUrl: './car-liner-forgot-password.component.scss',
  standalone: false
})
export class CarLinerForgotPasswordComponent extends ForgotPasswordComponent {

}
